var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoUploadCsv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 0a1 1 0 0 1 .117 1.993L29 2H8C4.625 2 2.122 4.054 2.004 7.005L2 7.222v48.89a5.889 5.889 0 0 0 5.668 5.884l.22.004h48.89c2.994 0 5.119-2.423 5.218-5.755L62 56V35a1 1 0 0 1 1.993-.117L64 35v21c0 4.407-2.855 7.862-6.974 7.996l-.248.004H7.888a7.889 7.889 0 0 1-7.884-7.643L0 56.11V7.222C0 3.054 3.369.117 7.737.003L8 0h21zm34.707.293a1 1 0 0 1 .083 1.32l-.083.094-36.18 36.182h18.25a1 1 0 0 1 .994.883l.007.117a1 1 0 0 1-.884.993l-.116.007-20.742-.003-.126-.017-.111-.03-.111-.044-.078-.04-.116-.08-.09-.08a1.01 1.01 0 0 1-.097-.11l-.068-.107-.05-.103-.042-.12-.03-.15-.006-.116V18.222a1 1 0 0 1 1.993-.116l.007.116.001 18.253L62.292.293a1 1 0 0 1 1.415 0z",
    fill: "#4E5978",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUploadCsv);
export default __webpack_public_path__ + "static/media/ico-upload-csv.b979c17a3c5fb0f979f85f3017b82b5b.svg";
export { ForwardRef as ReactComponent };